import React from "react";
import { CustomLink } from "./CustomLink";

export default function OrgCard({ data }) {  
  return (
    <CustomLink
      href={`/nonprofit/ein-${data?.ein}`}
    >
      <div
        className="flex items-center justify-center rounded-[11px] bg-white p-[30px] shadow-[0px_3px_22px_0px_#00000033] transition-all ease-in-out hover:scale-105 sm:px-4"
        style={{
          minHeight: "160px",
          height: '100%',
          boxShadow: "0px 3px 22px 0px rgba(0, 0, 0, 0.33)"
        }}
      >
        <div className="grid w-[90%] grid-cols-3 items-center">
          <div className="col-span-1 size-[74px] min-w-[74px] ">
            { data?.imageURL != null && data?.imageURL !== "" && (
            <img
                src={data?.imageURL}
                alt={data?.name}
                width={100}
                height={100}
              />
            )}
          </div>
          <div className="col-span-2">
            <h2 className="text-lg font-semibold">{data?.name}</h2>
            <p className="text-xs text-[#4D4D4D] ">{data?.address ? data?.address : ( data.city != '' ?  `${data?.city  }, ${  data?.state}` : "" )}</p>
          </div>
        </div>
      </div>
    </CustomLink>
  );
}
